(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceItemPriceInfoDeleteController', ServiceItemPriceInfoDeleteController);

    ServiceItemPriceInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'PriceInfoCustom'];

    function ServiceItemPriceInfoDeleteController($uibModalInstance, entity, PriceInfoCustom) {
        var vm = this;

        vm.priceInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            PriceInfoCustom.deletePriceInfoWithRelationsById(id).query(function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();
